import Vue from 'vue'

import ThousandsFilter from './thousands'

Vue.filter('thousands', ThousandsFilter)
